<form [formGroup]="specVoorheffingenFormGroup">
    <div class="row">
        <div formGroupName="specificatieVoorheffingen">
            <div formGroupName="opbouw">
                <div>
                    <snelstart-ui-number-form-control formControlName="totaleVoorheffingen"
                                                id="totaleVoorheffingen"
                                                label="totaleVoorheffingen"
                                                class="custom-input-150"
                                                [decimals]="0"
                                          align="right"
                                          prefix="€"
                                                align="right"
                                                [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                </div>
                <div>
                    <snelstart-ui-number-form-control formControlName="loonbelastingTegenwoordigeDienstbetrekking"
                                                id="loonbelastingTegenwoordigeDienstbetrekking"
                                                label="loonbelastingTegenwoordigeDienstbetrekking"
                                                class="custom-input-150"
                                                [decimals]="0"
                                          align="right"
                                          prefix="€"
                                                align="right"
                                                [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="loonbelastingVroegereDienstbetrekking"
                                                id="loonbelastingVroegereDienstbetrekking"
                                                label="loonbelastingVroegereDienstbetrekking"
                                                class="custom-input-150"
                                                [decimals]="0"
                                          align="right"
                                          prefix="€"
                                                align="right"
                                                [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                    <snelstart-ui-number-form-control formControlName="loonbelastingAlsOnderdeelVanWinst"
                                                id="loonbelastingAlsOnderdeelVanWinst"
                                                label="loonbelastingAlsOnderdeelVanWinst"
                                                class="custom-input-150"
                                                [decimals]="0"
                                          align="right"
                                          prefix="€"
                                                align="right"
                                                [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                </div>
                <div>
                    <snelstart-ui-number-form-control formControlName="dividendbelasting"
                                                      id="dividendbelasting"
                                                      label="dividendbelasting"
                                                      class="custom-input-150"
                                                      [decimals]="0"
                                          align="right"
                                          prefix="€"
                                                      align="right"
                                                      [attr.disabled]="true">
                    </snelstart-ui-number-form-control>
                </div>
            </div>
        </div>
    </div>
</form>
